export default "__VITE_ASSET__DQYYij2i__"